/* LUNAcycled "in stock brand new" (Liv, 09-23). Companion to luna-pdp.js, kept
   in its own file because luna-pdp.js is past what the API can upsert. It never
   reaches into luna-pdp's state: it reads the same JSON the page ships, patches
   the size chips luna-pdp renders, and drives the page by clicking luna-pdp's
   own buttons.

   offer(): on a LUNAcycled PDP carrying custom.brand_new_version. A size is
   offered brand new only when it is sold out HERE in every condition (Liv).
   Same colour first, then any colour; Imported first, then Made in USA. Those
   sold-out chips become clickable (dashed teal, same as the USA rescue) and the
   card links to the brand new PDP with ?variant=<id>, which luna-pdp honours
   (D400) by landing on that colour, origin and size.
   It also rescues across CONDITION on any product with that option, with or
   without the metafield: see the note at condRow(). */
(function(){
  if(window.__lunaCyc) return; window.__lunaCyc = true;
  function norm(s){ return String(s).toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function money(c){ return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : '$' + (c/100).toFixed(2); }
  function pretty(s){ return String(s).replace(/([a-z])([A-Z])/g, '$1 $2'); }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* Match sizes on the men's number: "M10.5" and "M10.5 W12.5" are one pair. */
  function mens(v){ var m = /M *([0-9.]+)/.exec(String(v)); return m ? m[1] : norm(v); }
  function idx(names, re){ for(var i = 0; i < names.length; i++){ if(re.test(names[i])) return i; } return -1; }
  function pdpData(root){
    try{ return JSON.parse(root.querySelector('[data-luna-pdp-data]').textContent); }catch(e){ return null; }
  }

  function offer(root){
    var own = pdpData(root);
    if(!own) return;
    var names = own.options.map(function(o){ return o.name; });
    var si = idx(names, /^siz(e|ing)$/i), ci = idx(names, /^condition$/i);
    var sizes = root.querySelector('[data-pdp-sizes]'), rescue = root.querySelector('[data-pdp-rescue]');
    if(si < 0 || !sizes || !rescue) return;
    var nu = null, el = document.querySelector('[data-luna-cyc-data]');
    if(el){ try{ nu = JSON.parse(el.textContent); }catch(e){ nu = null; } }
    var nsi = -1, nci = -1, noi = -1;
    if(nu){ nsi = idx(nu.options, /^siz(e|ing)$/i); nci = idx(nu.options, /colou?r/i); noi = idx(nu.options, /^origin$/i); }
    if(nsi < 0) nu = null;
    if(!nu && ci < 0) return;

    var card = document.createElement('div');
    rescue.parentNode.insertBefore(card, rescue.nextSibling);
    var want = nu ? norm(nu.colour || '') : '', cache = {};

    /* Condition rescue (Liv, 09-23): luna-pdp greys out a size that is sold out
       in the SELECTED condition even when the other condition has it, and
       nothing tells the shopper to switch. Same treatment as the USA rescue:
       dashed chip, then a card whose button clicks luna-pdp's own condition chip. */
    function row(name){
      var hit = null;
      root.querySelectorAll('[data-pdp-axes] [data-axis]').forEach(function(r){ if(r.dataset.axis === name) hit = r; });
      return hit;
    }
    function condRow(){ return row(names[ci]); }
    function picked(name){
      var r = row(name), b = r && r.querySelector('button[aria-current="true"]');
      return b ? b.dataset.v : null;
    }
    function condNow(){ return ci > -1 ? picked(names[ci]) : null; }
    /* Every other axis stays as the shopper set it. Mystery Roots also has a
       Footbed axis: "we have it in Great" must mean Great in the SAME footbed,
       or Switch lands on another sold-out pair. */
    function fits(v){
      return names.every(function(n, j){
        if(j === si || j === ci) return true;
        var p = picked(n);
        return p == null || v.o[j] === p;
      });
    }
    function inCond(size, cond){ return own.variants.some(function(v){ return v.o[si] === size && v.o[ci] === cond && v.a && fits(v); }); }
    function otherCond(size){
      var now = condNow(), hit = null;
      if(now == null || inCond(size, now)) return null;
      own.variants.forEach(function(v){ if(!hit && v.a && v.o[si] === size && v.o[ci] !== now && fits(v)) hit = v.o[ci]; });
      return hit;
    }
    function cap(s){ s = String(s); return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }

    function soldOutHere(size){ return !own.variants.some(function(v){ return v.o[si] === size && v.a; }); }
    function pick(size){
      if(!nu) return null;
      if(cache[size] !== undefined) return cache[size];
      var mn = mens(size), best = null, bestScore = 9;
      nu.variants.forEach(function(v){
        if(!v.a || mens(v.o[nsi]) !== mn) return;
        var score = 0;
        if(nci > -1 && want && norm(v.o[nci]) !== want) score += 2;
        if(noi > -1 && /usa/i.test(v.o[noi])) score += 1;
        if(score < bestScore){ best = v; bestScore = score; }
      });
      return (cache[size] = best);
    }
    function patch(){
      sizes.querySelectorAll('[data-s]').forEach(function(b){
        var s = b.dataset.s;
        if(otherCond(s) || (soldOutHere(s) && pick(s))){ b.disabled = false; b.classList.add('is-rescuable'); }
      });
      var on = sizes.querySelector('[data-s][aria-pressed="true"]');
      var size = on ? on.dataset.s : null;
      var to = size && otherCond(size);
      if(to){
        card.innerHTML = '<div class="luna-pdp__rescue"><b>' + esc(size) + '</b> is sold out in ' + esc(cap(condNow())) +
          ' condition, but we have it in ' + esc(cap(to)) + '.' +
          '<br><button type="button" data-cyc-cond="' + esc(to) + '">Switch to ' + esc(cap(to)) + '</button></div>';
        return;
      }
      var v = size && soldOutHere(size) ? pick(size) : null;
      if(!v){ card.innerHTML = ''; return; }
      var where = nci > -1 ? ' in ' + pretty(v.o[nci]) : '';
      if(noi > -1 && /usa/i.test(v.o[noi])) where += ' (Made in USA)';
      card.innerHTML = '<div class="luna-pdp__rescue"><b>' + esc(size) + '</b> is sold out in LUNAcycled, but it&rsquo;s in stock brand new' + esc(where) + '.' +
        '<br><a class="luna-cyc__go" href="' + esc(nu.url) + '?variant=' + v.id + '">Shop brand new &middot; ' + money(v.p) + '</a></div>';
    }
    /* luna-pdp rebuilds the chips on every change, so re-patch after each one.
       Only childList is watched: patch() itself changes attributes, not nodes. */
    new MutationObserver(patch).observe(sizes, { childList: true });
    card.addEventListener('click', function(e){
      var t = e.target.closest('[data-cyc-cond]'), r = t && condRow();
      if(!r) return;
      r.querySelectorAll('button[data-v]').forEach(function(b){ if(b.dataset.v === t.dataset.cycCond) b.click(); });
    });
    patch();
  }

  function boot(tries){
    var root = document.querySelector('[data-luna-pdp]');
    if(!root || root.__lunaCyc) return;
    if(!root.__luna){ if((tries || 0) < 40) setTimeout(function(){ boot((tries || 0) + 1); }, 50); return; }
    root.__lunaCyc = true;
    offer(root);
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ boot(0); }); }
  else { boot(0); }
})();
